import React, { useState, useEffect } from 'react'
import './styles.less'
import ProjectProposalWidget from '../../widgets/projectProposal/ProjectProposalWidget'
import TopLevelNav from '../../components/TopLevelNav'
import PageToolbar from '../../components/PageToolbar'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../utils/loading'
import { getProjectTemplate } from '../../redux/actions/projectTemplate'
import { Grid } from 'rsuite'
import ContentHeader from '../../components/ContentHeader/ContentHeader'

export default function SelectProposalFormDep6() {
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const mockSchema = {
    header: 'เลือกแบบเสนอโครงการที่ประกาศเปิดรับ',
    subHeader: null,
    projecCode: null,
    projecName: null,
    disabled: false,
    formTemplate: 0,
    forms: {
      buttonText: 'ตั้งค่าเริ่มต้น',
      items: [
        // {
        //   id: '5920C63A-97AE-4E09-B0B3-832F0A700DC8',
        //   name: 'โครงการเปิดรับทั่วไป',
        //   feedbackBySubject: null,
        //   defaultExpand: true,
        //   fiscalYear: { label: 'ปีงบประมาณ', value: null },
        //   proposalType: { label: 'ลักษณะการเปิดรับข้อเสนอโครงการ', value: null },
        //   openPeriod: { label: 'ระยะเวลาที่เปิดรับ', start: null, end: null },
        //   department: { label: 'หน่วยงาน', value: null },
        //   detail: { label: 'รายละเอียด', value: null },
        //   issues: {
        //     options: [
        //       {
        //         disabled: false,
        //         label: 'ข้อเสนอโครงการเปิดรับทั่วไป',
        //         value: '7E8A84C8-47AD-494B-AA3D-757EEC3D307F',
        //       },
        //     ],
        //     label: 'ประเด็นที่เปิดรับ',
        //     value: null,
        //   },
        // },
        {
          id: '984C543A-D337-4FD9-A08F-240DAAA05E91',
          name: 'โครงการสร้างเสริมสุขภาพทั่วไป ปี 2565',
          feedbackBySubject: null,
          defaultExpand: false,
          fiscalYear: { label: 'ปีงบประมาณ', value: 2565 },
          proposalType: {
            label: 'ลักษณะการเปิดรับข้อเสนอโครงการ',
            value: 'โครงการพัฒนาและปฏิบัติการ',
          },
          openPeriod: { label: 'ระยะเวลาที่เปิดรับ', start: '01 ม.ค. 2565', end: '31 ธ.ค. 2565' },
          department: { label: 'หน่วยงาน', value: 'สำนัก 6' },
          detail: {
            label: 'รายละเอียด',
            value:
              '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; โครงการทั่วไปที่ทาง "สำนักงานกองทุนสนับสนุนการสร้างเสริมสุขภาพ (สสส.)" เปิดรับประจำปี',
          },
          issues: {
            options: [
              {
                disabled: false,
                label: 'ลด ละ เลิก การดื่มแอลกอฮอล์ในชุมชน',
                value: '984C543A-D337-4FD9-A08F-240DAAA05E92',
              },
              {
                disabled: false,
                label: 'การจัดการขยะ',
                value: '984C543A-D337-4FD9-A08F-240DAAA05E93',
              },
              {
                disabled: false,
                label: 'การผลิตและบริโภคผักปลอดสารเคมีในครัวเรือน',
                value: '984C543A-D337-4FD9-A08F-240DAAA05E94',
              },
              {
                disabled: false,
                label: 'ส่งเสริมการบริโภคผัก ผลไม้ และภาวะโภชนาการของนักเรียนในโรงเรียน',
                value: '984C543A-D337-4FD9-A08F-240DAAA05E95',
              },
              {
                disabled: false,
                label: 'สร้างเสริมสุขภาพผู้สูงอายุในชุมชน',
                value: '984C543A-D337-4FD9-A08F-240DAAA05E96',
              },
              {
                disabled: false,
                label: 'การจัดการจุดเสี่ยงเพื่อป้องกันอุบัติเหตุทางถนนในชุมชน',
                value: '984C543A-D337-4FD9-A08F-240DAAA05E97',
              },
              {
                disabled: false,
                label: 'ลด ละ เลิก บุหรี่/ยาสูบโดยใช้ชุมชนเป็นฐาน',
                value: '984C543A-D337-4FD9-A08F-240DAAA05E98',
              },
              {
                disabled: false,
                label: 'ส่งเสริมกิจกรรมทางกายด้วยศิลปวัฒนธรรมไทย',
                value: '984C543A-D337-4FD9-A08F-240DAAA05E99',
              },
            ],
            label: 'ประเด็นที่เปิดรับ',
            value: null,
          },
        },
      ],
    },
  }

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await getProjectTemplate()
      // console.log('schema ', JSON.stringify(_schema))
      // setSchema(_schema)
      setSchema(mockSchema)
    } catch (e) {}
    doneLoading()
    setIsLoading(false)
  }

  return (
    <Grid className="page-home">
      <TopLevelNav />
      <PageToolbar />
      {!schema || isLoading ? (
        <PanalLoadingTemplate />
      ) : (
        <>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />
          <ProjectProposalWidget
            schema={schema?.forms?.items}
            buttonText={schema?.forms?.buttonText}
          />
        </>
      )}
    </Grid>
  )
}
